/* eslint-disable */
export default {
  ru: {
    label: 'Тариф',
    tariffs: {
      small: {
        title: 'Малый',
        description: '<p>Необходимый минимум для небольшого объема простых вакансий</p>',
      },
      professional: {
        title: 'Профессиональный',
        description:
          '<p>Передовые инструменты для автоматизации рутины, работы с&nbsp;заказчиками и&nbsp;аналитики подбора</p>',
      },
      maximum: {
        label: 'Выбор 200+ компаний!',
        title: 'Максимальный',
        description:
          '<p>Все возможности автоматизации для ускорения закрытия вакансий и&nbsp;решения любых задач рекрутмента</p>',
      },
      enterprise: {
        title: 'Премьер',
        description:
          '<p>Готовое решение для трансформации, систематизации и&nbsp;масштабирования рекрутмента в&nbsp;крупных компаниях</p>',
      },
    },
    price: {
      label: 'В&nbsp;месяц за&nbsp;одного рекрутера,<br> оплата за&nbsp;год',
      enterprise: 'Индивидуальный расчет',
    },
    button: 'Оставить заявку',
  },
  en: {
    label: 'Plan',
    tariffs: {
      small: {
        title: 'Not available',
        description: '<p>Not available</p>',
      },
      professional: {
        title: 'Professional',
        description:
          '<p>Advanced tools for automating routine tasks, working with hiring managers and data analytics</p>',
      },
      maximum: {
        label: '200+ companies picked it!',
        title: 'Maximum',
        description:
          '<p>Full automation to&nbsp;rapidly fill vacant positions and address any recruitment challenge</p>',
      },
      enterprise: {
        title: 'Premier',
        description:
          '<p>A&nbsp;ready-made solution for transforming, systematizing, and scaling the recruitment process in&nbsp;large companies</p>',
      },
    },
    price: {
      label: 'Per recruiter/month, billed annually',
      enterprise: 'Contact sales',
    },
    button: 'Request a&nbsp;demo',
  },
};
